import { AppError, CombinedError, isNotAuthenticatedError, isNotFoundError, isOfflineError } from "@chronosphereio/core";
import { MagnifyRemoveOutline, WifiOff } from "mdi-material-ui";
function getServerErrorMessages(error) {
    if (!(error instanceof CombinedError) || !(error.graphQLErrors.length > 0)) return;
    {
        const errorMessages = [];
        for (const graphqlError of error.graphQLErrors)errorMessages.push(graphqlError.message);
        return errorMessages;
    }
}
const DEFAULT_SUPPORT_URL = 'https://support.chronosphere.io';
const DEFAULT_SUPPORT_LABEL = 'Contact Chronosphere Support';
function getErrorDetails(error, options, config) {
    const supportUrl = config?.supportUrl ?? DEFAULT_SUPPORT_URL;
    const supportLabel = config?.supportLabel ?? DEFAULT_SUPPORT_LABEL;
    if (isNotAuthenticatedError(error)) return {
        icon: MagnifyRemoveOutline,
        severity: 'error',
        title: 'You are no longer logged in',
        message: 'Refresh your browser and contact Chronosphere support if the issue persists',
        link: error instanceof AppError ? void 0 : {
            url: supportUrl,
            label: supportLabel
        }
    };
    if (isOfflineError(error)) return {
        icon: WifiOff,
        severity: 'error',
        title: "It seems like you're offline",
        message: 'Check your network connection, and then refresh your browser.'
    };
    if (isNotFoundError(error)) return {
        headerText: '404',
        severity: 'error',
        title: error instanceof AppError ? error.title : "We can't find that resource",
        message: error instanceof AppError ? error.message : "The resource might not exist anymore, or there's a typo in the URL. Contact the owner for more information."
    };
    return {
        icon: MagnifyRemoveOutline,
        severity: options ? options.severity : error instanceof AppError ? error.severity : 'error',
        title: options ? options.title : error instanceof AppError ? error.title : 'Something happened on our end',
        message: options ? options.message : error instanceof AppError ? error.message : 'Refresh your browser and contact Chronosphere support if the issue persists',
        serverMessages: getServerErrorMessages(error),
        link: options || error instanceof AppError ? void 0 : {
            url: supportUrl,
            label: supportLabel
        }
    };
}
export { getErrorDetails, getServerErrorMessages };

//# sourceMappingURL=getErrorDetails.js.map